<template>
  <div class="og-title-bar">
    <div class="og-title-group">
      <div class="title">
        <div class="title-text">
            <slot name="titleName"></slot>
            <span>{{name}}</span>
        </div>
        <div class="title-btn">
          <el-popover
              v-if="isMobile && showMore"
              popper-class="btn-popover"
              placement="bottom"
              trigger="click"
          >
            <slot name="rightWrapper"/>
            <el-button size="mini" type="primary"  slot="reference">更多</el-button>
          </el-popover>
          <slot v-if="isMobile && !showMore"  name="rightWrapper"/>
        </div>
      </div>
      <div class="formWrapper">
        <slot name="formWrapper" />
      </div>
      <div class="rightWrapper" v-if="!isMobile">
        <slot name="rightWrapper"/>
      </div>
    </div>
    <fixed :position="position" :scrollTop="scrollTop" v-if="showFixed">
      <template slot="fixedWrapper">
        <slot name="fixedWrapper"/>
        <slot v-if="!$scopedSlots.fixedWrapper" name="rightWrapper"/>
      </template>
    </fixed>
  </div>
</template>

<script>
import AppDeviceEnquire from '../mixins/device.js'
import OgFixed from "./Fixed.vue";
export default {
  name: "BtTitleBar",
  components: {OgFixed},
  props:['name','showFixed','position','scrollTop','showMore'],
  mixins: [AppDeviceEnquire],
}
</script>

<style lang="scss">
.btn-popover{
  .el-button{
    display: block;
  }
  .el-button + .el-button{
    margin-left: 0;
    margin-top: 10px;
  }
  .el-button + .upload-demo {
    margin-left:0;
    margin-top: 10px;
  }
  .upload-demo + .el-button{
    margin-left: 0;
    margin-top: 10px;
  }
}
.og-title-group{
  display: flex;
  width: 100%;
  border-bottom: 1px solid #EEEEEE;
  .title {
    font-size: 16px;
    min-width: 100px;
    position: relative;
    display: flex;
    .title-text{
      height: 60px;
      line-height: 60px;
      width: fit-content;
      min-width: fit-content;
      border-bottom: 2px solid  #333333;
      margin-right: 20px;
      font-size: 25px;
    }
    .title-btn{
      overflow: auto;
      width: 0;
      flex: 1;
      display: flex;
      align-items: center;
        padding-right: 10px;
    }
  }
  .formWrapper{
    flex: 1;
    display: flex;
    align-items: center;
    margin-right: 20px;
  }
  .rightWrapper{
    display: flex;
    align-items: center;
    .el-button + .el-button{
      margin-left: 10px;
    }
    .el-button + .upload-demo {
      margin-left: 10px;
    }
    .upload-demo + .el-button{
      margin-left: 10px;
    }
  }
}
.title-btn::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}
@media (max-width: 768px) {
  .og-title-group {
    display: flex;
    flex-direction: column;
    border: 0;
    .title {
      flex: 1;
      margin:0 20px;
      border-bottom: 1px solid #EEEEEE;
    }
    .rightWrapper{
      flex: 1;
      margin:0 20px;
    }
    .formWrapper{
      flex: 1;
      margin:10px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TitleBar.vue